import {
	Integration,
	IntegrationFeatureOauth,
	IntegrationProviderId,
	IntegrationStatus,
	OauthScope,
	SettingsConfig,
	SettingsConfigType,
} from "../../../../index";

const airtableIntegration = new Integration({
	id: "airtable",
	name: "Airtable integration",
	description:
		"Airtable is a cloud-based spreadsheet-database hybrid that allows you to create custom databases for your team.",
	providerId: IntegrationProviderId.AIRTABLE,
	status: IntegrationStatus.ACTIVE,
	docsUrl: "",
	features: [
		new IntegrationFeatureOauth({
			id: "oauth",
			scopes: [
				new OauthScope({
					id: "userinfo",
					name: "User Info",
					description: "View your basic profile info",
					required: true,
					key: "user.email:read",
					usedByAddOns: [],
				}),
				new OauthScope({
					id: "full_read",
					name: "Full read access",
					description: "View all data in your Airtable bases",
					required: false,
					key: "data.records:read",
					usedByAddOns: [],
				}),
				new OauthScope({
					id: "full_write",
					name: "Full write access",
					description: "Edit all data in your Airtable bases",
					required: false,
					key: "data.records:write",
					usedByAddOns: [],
				}),
			],
		}),
	],
	settingsConfig: [
		new SettingsConfig({
			id: "display_name",
			label: "Integration name",
			description:
				"The name of the integration that will be displayed in the integrations list",
			type: SettingsConfigType.STRING,
			required: true,
			editable: true,
			encrypted: false,
		}),
		new SettingsConfig({
			id: "oauth",
			label: "Select access scopes",
			type: SettingsConfigType.OAUTH,
			description:
				"Select the access scopes you want to give to the integration, we recommend giving only the scopes that are necessary for the integration to work. This can be changed later.",
			required: true,
			editable: true,
		}),
	],
});

export default airtableIntegration;
